
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import FinanceiroTabs from "@/components/financeiro/FinanceiroTabs";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Tags, Users, Webhook } from "lucide-react";
import { Toaster } from "sonner";

import ConfiguracoesHeader from "@/components/financeiro/configuracoes/ConfiguracoesHeader";
import CategoriasTabContent from "@/components/financeiro/configuracoes/CategoriasTabContent";
import PermissoesTabContent from "@/components/financeiro/configuracoes/PermissoesTabContent";
import IntegracoesTabContent from "@/components/financeiro/configuracoes/IntegracoesTabContent";

const FinanceiroConfiguracoesPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("categorias");
  const [tabAtiva, setTabAtiva] = useState("configuracoes");
  
  const handleTabChange = (value: string) => {
    setTabAtiva(value);
    
    const event = new CustomEvent('change-tab', {
      detail: { tab: value }
    });
    window.dispatchEvent(event);
    
    const url = new URL(window.location.href);
    url.searchParams.set('tab', value);
    window.history.pushState({}, '', url);
  };
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    if (tab) {
      setTabAtiva(tab);
    }
  }, []);
  
  return (
    <Layout>
      <div className="container mx-auto p-4 md:p-6 max-w-7xl">
        <ConfiguracoesHeader />
        <div className="w-full rounded-lg shadow-sm overflow-hidden">
          <FinanceiroTabs 
            tabAtiva={tabAtiva} 
            onChangeTab={handleTabChange} 
            variant="buttons"
            className="overflow-x-auto pb-2 md:pb-0" 
          />
        </div>
        
        <Tabs defaultValue={activeTab} onValueChange={setActiveTab} className="w-full mt-6">
          <TabsList className="w-full justify-start overflow-x-auto mb-6 bg-gray-50 p-1 rounded-lg">
            <TabsTrigger 
              value="categorias"
              className="flex items-center gap-2 data-[state=active]:bg-white data-[state=active]:shadow-sm"
            >
              <Tags className="h-4 w-4" />
              Categorias
            </TabsTrigger>
            
            <TabsTrigger 
              value="permissoes"
              className="flex items-center gap-2 data-[state=active]:bg-white data-[state=active]:shadow-sm"
            >
              <Users className="h-4 w-4" />
              Permissões
            </TabsTrigger>
            
            <TabsTrigger 
              value="integracoes"
              className="flex items-center gap-2 data-[state=active]:bg-white data-[state=active]:shadow-sm"
            >
              <Webhook className="h-4 w-4" />
              Integrações
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="categorias" className="pt-2 animate-in fade-in-50">
            <CategoriasTabContent />
          </TabsContent>
          
          <TabsContent value="permissoes" className="pt-2 animate-in fade-in-50">
            <PermissoesTabContent />
          </TabsContent>
          
          <TabsContent value="integracoes" className="pt-2 animate-in fade-in-50">
            <IntegracoesTabContent />
          </TabsContent>
        </Tabs>
        
        <Toaster position="top-right" />
      </div>
    </Layout>
  );
};

export default FinanceiroConfiguracoesPage;
